import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(['user', 'card']),
    getByUser: state => user => {
      return state.objs.filter(uc => uc.user === user);
    },
    getByCard: state => card => {
      return state.objs.filter(uc => uc.card === card);
    }
  },
  mutations: {
    ...functions.createDefaultMutations(['user', 'card']),
  },
  actions: {
    ...functions.createDefaultActionsWithStore(['user', 'card'])
  },
}